import { styled, TextField } from '@mui/material';

export const PKDTextInput = styled(TextField)(({ theme, error }) => ({
  fontFamily                 : 'Montserrat',
  '& .MuiOutlinedInput-root' : {
    borderRadius : '8px',
    border       : `1px solid ${
      error ? theme.palette.primary.red75 : theme.palette.primary.gray4
    }`,
    '&.Mui-focused' : {
      '& .MuiOutlinedInput-notchedOutline' : {
        border : `2px solid ${
          error ? theme.palette.primary.red75 : theme.palette.primary.greenPKD
        }`,
      },
    },
  },
  '& .MuiInputBase-input, .MuiOutlinedInput-root' : {
    border : 'none',
  },
  '& .MuiInputLabel-root' : {
    backgroundColor : theme.palette.primary.white,
    fontFamily      : 'Montserrat',
    border          : 'none',
    '&.Mui-focused' : {
      color : error
        ? theme.palette.primary.red75
        : theme.palette.primary.greenPKD,
    },
  },
}));
